'use strict';

var userAgent = require('../internals/environment-user-agent');
module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';